export default __webpack_public_path__ + "static/media/laponia.7d3d8199.jpg";